<template>
  <div>
    <div v-if="loading">
      <v-skeleton-loader
        type="card"
        :min-width="$vuetify.breakpoint.smAndDown ? '' : 400"
        class="mx-auto"
      />
    </div>

    <div
      v-else-if="verificationSteps.length > 0"
      class="colorMainBackground colorDefault"
    >
      <v-expansion-panels v-model="activeStep">
        <v-expansion-panel
          v-for="(item, i) in verificationSteps"
          :key="item.nameId"
        >
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <div>
                {{ item.name }}
              </div>
              <v-chip
                :color="chips[item.nameId][item.playerStatus].color"
                class="ml-2"
                small
                style="cursor: pointer"
              >
                {{ chips[item.nameId][item.playerStatus].text }}
              </v-chip>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <DocumentVerification
              v-if="item.nameId === 'document_verification'"
              :verificationStatus="item.playerStatus"
              :userCpf="userCpf"
              @changeDocumentVerificationStatus="
                changeDocumentVerificationStatus
              "
            />
            <EmailVerification
              v-else-if="item.nameId === 'email_verification'"
              :verificationStatus="item.playerStatus"
              :userEmail="userEmail"
              @changeEmailVerificationStatus="changeEmailVerificationStatus"
            />
            <PhoneVerification
              v-else-if="item.nameId === 'phone_verification'"
              :verificationStatus="item.playerStatus"
              @changePhoneVerificationStatus="changePhoneVerificationStatus"
            />
            <BankVerification
              v-else
              :verificationStatus="item.playerStatus"
              @changeBankVerificationStatus="changeBankVerificationStatus"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import DocumentVerification from "./DocumentVerification.vue";
import EmailVerification from "./EmailVerification.vue";
import PhoneVerification from "./PhoneVerification.vue";
import BankVerification from "./BankVerification.vue";

export default {
  data: (_this) => ({
    verificationSteps: [{ nameId: "", name: "", playerStatus: "" }],

    loading: true,
    verificationStatus: {
      document_verification: { active: 0, playerStatus: 0, name: "" },
      bank_verification: { active: 0, playerStatus: 0, name: "" },
      email_verification: { active: 0, playerStatus: 0, name: "" },
      phone_verification: { active: 0, playerStatus: 0, name: "" },
    },
    userCpf: "",
    userEmail: "",

    chips: {
      bank_verification: {
        0: {
          text: _this.$t("verification.status.actionNeeded"),
          color: "#F64B20",
        },
        1: {
          text: _this.$t("verification.status.finished"),
          color: "#4CAF50",
        },
        2: {
          text: _this.$t("verification.status.inProgress"),
          color: "#FFEB3B",
        },
        3: {
          text: _this.$t("verification.status.denied"),
          color: "#FF2929",
        },
      },
      document_verification: {
        1: {
          text: _this.$t("verification.status.actionNeeded"),
          color: "#F64B20",
        },
        2: {
          text: _this.$t("verification.status.inProgress"),
          color: "#FFEB3B",
        },
        3: {
          text: _this.$t("verification.status.finished"),
          color: "#4CAF50",
        },
        4: {
          text: _this.$t("verification.status.denied"),
          color: "#FF2929",
        },
      },
      email_verification: {
        0: {
          text: _this.$t("verification.status.pendent"),
          color: "#F64B20",
        },
        1: {
          text: _this.$t("verification.status.finished"),
          color: "#4CAF50",
        },
      },
      phone_verification: {
        0: {
          text: _this.$t("verification.status.pendent"),
          color: "#F64B20",
        },
        1: {
          text: _this.$t("verification.status.finished"),
          color: "#4CAF50",
        },
      },
    },

    activeStep: null,
  }),

  components: {
    DocumentVerification,
    EmailVerification,
    PhoneVerification,
    BankVerification,
  },

  created() {
    this.fetchVerificationStatus();
  },

  methods: {
    changeDocumentVerificationStatus(status) {
      this.verificationSteps.forEach((step) => {
        if (step.nameId === "document_verification") {
          step.playerStatus = status;
        }
      });
    },
    changeBankVerificationStatus(status) {
      this.verificationSteps.forEach((step) => {
        if (step.nameId === "bank_verification") {
          step.playerStatus = status;
        }
      });
    },
    changeEmailVerificationStatus() {
      this.fetchVerificationStatus();
    },
    changePhoneVerificationStatus() {
      this.fetchVerificationStatus();
    },
    fetchVerificationStatus() {
      this.$axios
        .get("/player/profile/verificationStatus")
        .then((res) => {
          this.userCpf = res.data.userCpf;
          this.userEmail = res.data.userEmail;
          this.verificationStatus = res.data.dados;

          const verificationSteps = [];

          for (const step in this.verificationStatus) {
            if (
              this.verificationStatus[step].active == "1"
              && step != "two_steps_verification"
            ) {
              verificationSteps.push({
                nameId: step,
                name: this.verificationStatus[step].name,
                playerStatus: this.verificationStatus[step].playerStatus,
              });
            }
          }

          this.verificationSteps = verificationSteps;

          if (this.$route.query.open) {
            const step = this.verificationSteps.findIndex((step) => {
              return this.$route.query.open === step.nameId;
            });

            this.activeStep = step;
            this.$handleURLState("open", "delete");
          }
        })
        .catch(() => {
          this.verificationSteps = [];

          this.$router.push("/bt");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    scrollTo(id) {
      document.getElementById(id).scrollIntoView();
    },
  },
};
</script>
